export const experiences = [
  {
    year: "2021",
    name: "Software Engineer",
    company: "Databricks",
    place: "San Francisco, US",
    date: "Sep 2021 - current",
    description:
      "Working as a Frontend Engineer on the Databricks' Delta Live Tables team.",
    details: [
      "Improving and adding new features to the Delta Live Tables UI using React, Typescript, GraphQL and Jest.",
      "My recent projects have involved graph visualization with React Flow."
    ],
    tags: ["Frontend", "Programming"]
  },
  {
    year: "2020",
    name: "Software Developer Intern",
    company: "Atlassian",
    place: "Brisbane, AU",
    date: "Nov 2020 - Feb 2021",
    description:
      "Remotely completing a 12-week internship on the Atlassian Frontend Platform Team in the Monorepo stream (Sydney-based).",
    details: [
      "Built a full-stack deployment management app alongside a graduate engineer with TypeScript, React, Express and Postgres. The project was highly requested and delivered ahead of schedule.",
      "Added custom metrics using SignalFX and StatsD to a tool that queues and lands merges in the monorepo.",
      "Developed a Spotify-integrated Slack bot for the Atlassian hackathon with two other interns.",
      "Improved team processes by identifying a need for and writing a team onboarding guide and was a major contributor to a team health working group focused on improving work/life balance and burnout."
    ],
    tags: ["Full-stack", "Programming"]
  },
  {
    year: "2020",
    name: "GetAhead+ Participant",
    company: "Google",
    place: "Brisbane, AU",
    date: "Sep 2020 - Oct 2020",
    description:
      "Get Ahead+ is an exclusive 6-week virtual program that gives participants practical technical experience.",
    details: [
      "Program activities: Weekly coding challenges, group coaching sessions, mock interview, and talks on technical career paths at Google."
    ],
    tags: ["Programming"]
  },
  {
    year: "2020",
    name: "Academic Tutor",
    company: "University of Queensland",
    place: "Brisbane, AU",
    date: "Feb 2017 - Jul 2020",
    description:
      "Tutored undergraduate and postgraduate classes as a casual academic demonstrator with an average performance rating of 4.7 / 5.",
    details: [
      "Created learning resources including workbooks, tutorials and practical content used by over 500 students each semester.",
      "Led tutorial and practical classes of up to 50 students in system and network programming and embedded systems in C.",
      "Taught relational database design and SQL and managed the peer learning tool and assessment feedback.",
      "Guided students through user-centred design team projects.",
      "Co-led practical classes and experiments on engineering material properties."
    ],
    tags: ["Teaching", "Content Development", "Programming", "Design"]
  },
  {
    year: "2020",
    name: "Startup Academy",
    company: "University of Queensland",
    place: "Brisbane, AU",
    date: "Mar 2020 - May 2020",
    description:
      "Participated in an exclusive 3-month entrepreneurship program to develop a validated business model for a startup.",
    details: [
      "Completed the program in a team of two with our startup, Stitchables, an automated service to turn virtual designs into DIY stitched toy kits.",
      "Learnt market validation, user interviewing and pitching skills.",
      "Awarded 4th place at the final pitching event along with prize money to take the idea to market."
    ],
    tags: ["Startup", "Pitching"]
  },
  {
    year: "2019",
    name: "New Colombo Plan Scholar",
    company: "Department of Foreign Affairs and Trade (Australia)",
    place: "Daejeon, KR + Bangalore, IN",
    date: "Nov 2018 - Dec 2019",
    description:
      "Sponsored to undertake semester-based study, language training and internships in South Korea and India.",
    details: [
      "The Australian Government’s most prestigious undergraduate scholarship awarded to 125 students each year.",
      "Scholarship cohort representative speaker at Parliament House.",
      "Speaker in the NCP Alumni Webinar: Entrepreneurship and Innovation in the Indo-Pacific."
    ],
    tags: ["Public Speaking", "Abroad"]
  },
  {
    year: "2019",
    name: "Robotics Intern",
    company: "Infosys Limited",
    place: "Bangalore, IN",
    date: "Jul 2019 - Aug 2019",
    description:
      "8-week global internship program with Infosys Center for Emerging Technology Solutions (iCETS).",
    details: [
      "Co-programmer for a collaborative path-finding and collision avoidance project using low-cost robotic solutions.",
      "Identified areas for improvement in pre-existing iCETS robotics projects to develop my own project proposal.",
      "Concept designer for a multi-intern SLAM robotics project.",
      "The internship program was rated No. 1 in the world by Valve in 2019 and 2020."
    ],
    tags: ["Robotics", "Abroad"]
  },
  {
    year: "2019",
    name: "Software Testing Intern",
    company: "Pipefish Pty Ltd",
    place: "Brisbane, AU",
    date: "Dec 2018 - Jan 2019",
    description:
      "Assisted with unit and regression testing Rio Tinto’s Ticketing Management System (ServiceNow implementation).",
    details: [],
    tags: ["Unit Testing", "Enterprise Software"]
  },
  {
    year: "2019",
    name: "Summer UX Research Scholar",
    company: "University of Queensland",
    place: "Brisbane, AU",
    date: "Nov 2018 - Feb 2019",
    description:
      "Awarded a UQ Summer Research Scholarship to design and prototype an assistive technology concept for people living with dementia.",
    details: [],
    tags: ["Prototyping", "UX Design"]
  },
  {
    year: "2018",
    name: "Shanghai Start Up Adventure",
    company: "Bitcurate",
    place: "Shanghai, CN",
    date: "Jul 2018",
    description:
      "4-week university-sponsored internship program specialising in Chinese start up culture.",
    details: [
      "Worked as a front-end developer in an early-stage cryptocurrency-analytics start up.",
      "Developed a website which received 2.8k views within two weeks."
    ],
    tags: ["Startup", "Web Dev", "Abroad"]
  },
  {
    year: "2017",
    name: "IT Exchange",
    company: "Dalian Neusoft University of Information",
    place: "Dalian, CN",
    date: "Jul 2017",
    description:
      "4-week NCP-sponsored exchange to study innovation, entrepreneurship and start ups in China.",
    details: [
      "Completed a team project to develop a startup concept alongside Australian and Chinese students.",
      "Worked as a product and UX designer for an app which promotes public-transport usage through gamification.",
      "Undertook Chinese language and culture classes."
    ],
    tags: ["Startup", "Abroad", "UX Design"]
  },
  {
    year: "2017",
    name: "Professional Chess Coach",
    company: "Gardiner Chess",
    place: "Brisbane, AU",
    date: "Jun 2016 - Jun 2017",
    description:
      "Recruited to teach chess across 9 Brisbane primary schools. Individually led classes in chess strategies and tactics.",
    details: [],
    tags: ["Teaching"]
  }
];
